import { toBoolOrNull, toIntOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type { IAssessCancerFormValues, IAssessCancerModel, IAssessCancerSubmitResult } from '@/types/screening/assess-cancer';

const ASSESS_CANCER_ENDPOINT = '/api/register/assess-cancer';

const defaultAssessCancerModel: IAssessCancerModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.AssessCancer,
    hasHadCancer: null,
    cancers: [],
};

export const useAssessCancer = (registrationId: number, editKey: string) => {
    const url = `${ASSESS_CANCER_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultAssessCancerModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<IAssessCancerFormValues, DashRegistrationStep, IAssessCancerSubmitResult>(
        url,
        (values) => {
            const hasHadCancer = toBoolOrNull(values.hasHadCancer);
            const cancers =
                hasHadCancer === true
                    ? values.cancers
                          .filter((c) => c.cancerType)
                          .map((c) => ({
                              cancerType: toIntOrNull(c.cancerType),
                              remissionStatus: toIntOrNull(c.remissionStatus),
                          }))
                    : [];

            return {
                hasHadCancer,
                cancers,
            };
        },
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
